import { defineStore } from 'pinia'

export * from './products'
export * from './loader'

export type TestimonialContext = {
	user_name: string
	planCategory: string
	testimony: string
	color_tag?: string
}[]
export const useStore = defineStore('store', {
	state: () => ({
		notificationMessage: '',
		notificationStatus: 0,
		notificationModal: false,
		states: <string[]>[],
		loadingDashboard: false,
		loaderText: '',
		waitListModal: false,
		socials: [
			{
				url: 'https://www.linkedin.com/company/mycovergenius/',
				label: 'LinkedIn',
				iconName: 'linkedin',
				active: 'linkdin-2'
			},
			{
				url: 'https://www.facebook.com/mycovergenius/',
				label: 'Facebook',
				iconName: 'facebook',
				active: 'facebook-main'
			},

			{
				url: 'https://www.youtube.com/@mycovergenius',
				label: 'YouTube',
				iconName: 'youtube',
				active: 'youtube-2'
			},
			{
				url: 'https://www.instagram.com/mycovergenius?igsh=Y3Fya2tuaXl5end3',
				label: 'Instagram',
				iconName: 'instagram',
				active: 'instagram-2'
			},
			{
				url: 'https://x.com/mycovergenius?s=21',
				label: 'X',
				iconName: 'twitter',
				active: 'twitter-main'
			}
		],
		marketingChannels: [
			'twitter',
			'instagram',
			'google',
			'facebook',
			'website',
			'bdm',
			'sales_team',
			'sales_agent',
			'techcabal',
			'technext',
			'naira metrics',
			'chowdeck',
			'businessday',
			'punch',
			'jennifer',
			'jumoke',
			'angela',
			'alma',
			'dochase',
			'dochmpdgen'
		]
	}),
	getters: {
		Socials(state) {
			return state.socials
		}
	},
	actions: {
		toggleModal(value: boolean) {
			const state = this.$state
			state.notificationModal = value
		},
		toggleWaitlistModal() {
			this.waitListModal = !this.waitListModal
		}
	}
})
